document.addEventListener('DOMContentLoaded', function () {
    // Hitta alla instanser av komponenten
    document.querySelectorAll('.pc-events').forEach((component) => {
        const loadMoreButton = component.querySelector('.btn-load-more-events')
        const eventsListing = component.querySelector('.events-listing')
        const eventsDataElement = component.querySelector('.events-data')
        const componentId = component.getAttribute('data-event_section_id')

        // Skapa unika nycklar för denna komponent
        const sessionKey = `loadedEventIds_${componentId}`
        const pagedKey = `currentPage_${componentId}`

        if (!loadMoreButton || !eventsListing) return

        // Återställ tillstånd vid sidladdning
        const storedIds = sessionStorage.getItem(sessionKey)
        const storedPaged = sessionStorage.getItem(pagedKey)
        let paged = storedPaged ? parseInt(storedPaged, 10) : 2

        if (storedIds) {
            const ids = JSON.parse(storedIds)
            const formData = new FormData()
            formData.append('action', 'get_loaded_events')
            formData.append('security', liGlobal.loadMore)
            formData.append('ids', ids.join(','))

            fetch(liGlobal.ajaxUrl, {
                method: 'POST',
                body: formData,
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.success) {
                        data.data.posts.forEach((post) => {
                            const tempDiv = document.createElement('div')
                            tempDiv.innerHTML = post.trim()
                            eventsListing.appendChild(tempDiv.firstChild)
                        })
                    }
                })
                .catch((error) => console.error('Error restoring events:', error))
        }

        // Klickhändelse för att ladda fler events
        loadMoreButton.addEventListener('click', function () {
            const button = this
            button.disabled = true
            button.textContent = 'Loading...'

            const formData = new FormData()
            formData.append('action', 'load_more_events')
            formData.append('security', liGlobal.loadMore)
            formData.append('paged', paged)
            formData.append('exclude', eventsDataElement ? eventsDataElement.dataset.exclude || '' : '')

            fetch(liGlobal.ajaxUrl, {
                method: 'POST',
                body: formData,
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.success) {
                        const loadedIds = []
                        data.data.posts.forEach((post) => {
                            const tempDiv = document.createElement('div')
                            tempDiv.innerHTML = post.trim()
                            eventsListing.appendChild(tempDiv.firstChild)
                            const idMatch = post.match(/data-event-id="(\d+)"/)
                            if (idMatch) {
                                loadedIds.push(parseInt(idMatch[1], 10))
                            }
                        })

                        // Spara laddade ID:n och paged för denna komponent
                        const currentStoredIds = sessionStorage.getItem(sessionKey)
                        const allIds = currentStoredIds ? [...JSON.parse(currentStoredIds), ...loadedIds] : loadedIds
                        sessionStorage.setItem(sessionKey, JSON.stringify(allIds))

                        paged++
                        sessionStorage.setItem(pagedKey, paged)

                        if (paged > data.data.max_num_pages) {
                            button.style.display = 'none'
                        } else {
                            button.textContent = 'Load more'
                            button.disabled = false
                        }
                    } else {
                        button.textContent = 'No more events'
                        button.disabled = true
                    }
                })
                .catch((error) => {
                    console.error('Error loading more events:', error)
                    button.textContent = 'Try again'
                    button.disabled = false
                })
        })
    })
})
